<p-dialog [header]="title"
          [visible]="isVisible"
          (visibleChange)="!$event && requestClose()"
          [modal]="true"
          [style]="{width: '900px'}"
          [maximizable]="true"
          [draggable]="false"
          [closeOnEscape]="false"
          styleClass="compose-dialog">

  <p-messages *ngIf="error" severity="error" [closable]="false">
    <ng-template pTemplate>
      <div class="flex flex-column gap-2">
        <span>{{error.message}}</span>
        <small class="text-color-secondary">El mensaje sigue aquí: puedes corregir y volver a enviarlo.</small>
      </div>
    </ng-template>
  </p-messages>

  <!-- input-field: el tamaño de campo del resto de la aplicacion (assets/css/forms.css) -->
  <div class="compose-grid input-field">
    <span class="compose-label text-color-secondary">De:</span>
    <span class="compose-from">
      {{accountName}} <span class="text-color-secondary" *ngIf="accountAddress">&lt;{{accountAddress}}&gt;</span>
    </span>

    <span class="compose-label text-color-secondary">Para:</span>
    <div class="flex align-items-start gap-2">
      <app-address-chips class="flex-grow-1" [(ngModel)]="to" placeholder="Escribe una dirección y pulsa Intro"></app-address-chips>
      <p-button *ngIf="!showCc" label="CC" size="small" [text]="true" severity="secondary" (click)="showCc = true"></p-button>
      <p-button *ngIf="!showBcc" label="CCO" size="small" [text]="true" severity="secondary" (click)="showBcc = true"></p-button>
    </div>

    <ng-container *ngIf="showCc">
      <span class="compose-label text-color-secondary">CC:</span>
      <app-address-chips [(ngModel)]="cc"></app-address-chips>
    </ng-container>

    <ng-container *ngIf="showBcc">
      <span class="compose-label text-color-secondary">CCO:</span>
      <app-address-chips [(ngModel)]="bcc"></app-address-chips>
    </ng-container>

    <span class="compose-label text-color-secondary">Asunto:</span>
    <input pInputText [(ngModel)]="subject" class="w-full" placeholder="Asunto del mensaje" />
  </div>

  <!-- TinyMCE y no p-editor: Quill normaliza el HTML a su propio modelo y descartaria la cita del original con su
       blockquote, las tablas y la firma. TinyMCE respeta el HTML que se le da.

       El *ngIf es a proposito: crea un editor nuevo en cada apertura en lugar de reutilizar el anterior, que podia
       arrastrar el contenido de la respuesta previa. Al crearse, el valor ya esta puesto y lo toma de una vez. -->
  <editor *ngIf="isVisible" class="compose-editor" [init]="editorInit" [(ngModel)]="htmlBody"></editor>

  <div class="compose-attachments" *ngIf="attachments.length > 0 || forwardedParts.length > 0">
    <div *ngFor="let attachment of attachments" class="compose-attachment">
      <i class="pi pi-paperclip"></i>
      <span class="compose-attachment-name">{{attachment.fileName}}</span>
      <small class="text-color-secondary">{{sizeLabel(attachment.size)}}</small>
      <i class="pi pi-times compose-attachment-remove" (click)="removeAttachment(attachment.fileId)"></i>
    </div>

    <!-- los del original no se han subido: los relee el servidor del buzon al enviar -->
    <div *ngFor="let part of forwardedParts" class="compose-attachment">
      <i class="pi pi-reply"></i>
      <span class="compose-attachment-name">{{part.fileName}}</span>
      <small class="text-color-secondary">{{sizeLabel(part.size)}} · del original</small>
      <i class="pi pi-times compose-attachment-remove" (click)="removeForwardedPart(part.partId)"></i>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex align-items-center gap-2 w-full">
      <p-fileUpload mode="basic" [auto]="false" [multiple]="true" chooseIcon="pi pi-paperclip"
                    chooseLabel="Adjuntar" [disabled]="uploading || sending"
                    (onSelect)="onFileSelect($event)"></p-fileUpload>

      <p-progressSpinner *ngIf="uploading" [style]="{width: '20px', height: '20px'}" strokeWidth="6"></p-progressSpinner>

      <div class="flex-grow-1"></div>

      <p-button label="Descartar" icon="pi pi-times" [text]="true" severity="secondary"
                [disabled]="sending" (click)="requestClose()"></p-button>
      <p-button label="Enviar" icon="pi pi-send" [disabled]="!canSend" [loading]="sending" (click)="send()"></p-button>
    </div>
  </ng-template>
</p-dialog>
